import React from 'react';
import language from '../../assets/languages/language';

function ValidateButton({ onValidate, disabled }) {
  return (
    <button
      className='btn btn-primary validate-button'
      onClick={onValidate}
      disabled={disabled}
    >
      {language.LC().VALIDATE}
    </button>
  );
}

export default ValidateButton;


// WEBPACK FOOTER //
// ./src/Components-2025/QuestionBank/ValidateButton.jsx